// import axios from 'axios'
// import MockAdapter from 'axios-mock-adapter'
// 
// const ServicePath = "http://localhost:9015/"
const ServicePath = "https://stagingservice.dentagenix.com/"
// const ServicePath = "https://service.dentagenix.com/"

export default ServicePath
